export default  {
    // Alternative: ./data/verbiss_2021.geojson
    DEFAULT_GEOJSON: './data/verbiss_2021.geojson',
    DEFAULT_CENTER: [1555177.2139329056,6008076.9581957515],
    // 'deckgl' || 'leaflet' || 'openlayers'
    FRAMEWORK: 'openlayers'
};

const deckGlConfig = {
    // Alternative: verbissproz_ob_drittel
    GEOJSON_PROPERTY_NAME: 'value',
    GEOJSON_PROPERTY_NAME_READABLE: 'Verbissprozent',
    GEOJSON_PROPERTY_UNIT: '%',
    DEFAULT_HEXAGON_RADIUS: 500,
    TILE_SERVER: [
        'https://services.arcgisonline.com/arcgis/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}'
    ]
}

const persionalization = {
    REPOSITORY_URL: 'https://github.com/b-lack/map-sense'
}

export {deckGlConfig, persionalization};